import { ConfigProvider } from 'antd';
import appTheme from '@theme';
import './App.css';
import AppRoutes from '@routes';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { RefundModalProvider } from '@/context/refund-modal/RefundModal';
import { AuthProvider } from '@/context/Auth';
import { ChatProvider } from '@/context/Chat';
import { NotificationProvider } from '@/context/Notification';
import { MapViewModalProvider } from '@/context/map-view-modal/MapViewModal';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnMount: true,
      refetchOnWindowFocus: false,
      staleTime: 0,
      retry: 1,
    },
  },
});

function App() {
  return (
    <ConfigProvider theme={appTheme}>
      <QueryClientProvider client={queryClient}>
        <AuthProvider>
          <NotificationProvider>
            <ChatProvider>
              <RefundModalProvider>
                <MapViewModalProvider>
                  <AppRoutes />
                </MapViewModalProvider>
              </RefundModalProvider>
            </ChatProvider>
          </NotificationProvider>
        </AuthProvider>
      </QueryClientProvider>
    </ConfigProvider>
  );
}

export default App;
